var map = {
	"./certifier.svg": "e940",
	"./consumer.svg": "4c47",
	"./producer.svg": "3ccd",
	"./recycler.svg": "dc66",
	"./remanufacturer.png": "690d",
	"./remanufacturer.svg": "2015",
	"./service.svg": "44de"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2a7a";